import React from 'react'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'

/**
 * Reusable delete confirm modal.
 * - If errorMessage exists, it turns into an error/info modal with only "Close".
 * - Else it shows confirm with "Delete" + "Cancel".
 */
const DeleteDepartmentModal = ({
    open,
    onClose,
    onConfirm,
    title = 'Delete this department?',
    subtitle = 'Are you sure you want to delete this department?',
    errorMessage = '',
    isLoading = false,
}) => {
    const isError = Boolean(errorMessage)

    return (
        <AdxInfoModal
            open={open}
            onClose={onClose}
            handleClose={onClose}
            muiIcon={isError ? 'error' : 'warning'}
            iconColor="warning.main"
            title={isError ? 'Unable to delete' : title}
            subtitle={isError ? errorMessage : subtitle}
            footerButtons
            firstBtnLabel={isError ? 'Close' : isLoading ? 'Deleting...' : 'Delete'}
            firstBtnHandle={isError ? onClose : onConfirm}
            secondBtnLabel={isError ? '' : 'Cancel'}
            secondBtnHandle={isError ? undefined : onClose}
        />
    )
}

export default DeleteDepartmentModal
